export const MAPS_BASE_URL = "https://neomap.neoffice.app"; /*https://maps.myatom.in*/
